import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

export interface IEventObject {
  event: string;
  data: any;
}

@Injectable()
export class EventServiceProvider {
  eventsrc: Subject<IEventObject> = new Subject<IEventObject>();
  event$ = this.eventsrc.asObservable();
  constructor() {
    console.log('Hello EventServiceProvider Provider');
  }
  trigEvent(obj: any) {
    this.eventsrc.next(obj);
  }

}



// WEBPACK FOOTER //
// ./src/providers/event-service/event-service.ts